import axios from 'axios'
import config from '../config'
import {JsonHeaders} from '../constants';

export default {
    uuidDecode(data) {
        return axios.post(config.publicPath + 'uuid-decode', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    uuidEncode(data) {
        return axios.post(config.publicPath + 'uuid-encode', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    emailIdDecode(data) {
        return axios.post(config.publicPath + 'email-id-decode', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    emailIdEncode(data) {
        return axios.post(config.publicPath + 'email-id-encode', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    getIpHistory(data) {
        data = JSON.stringify({ip: data});
        return axios.post(config.publicPath + 'ip-history', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    getDomainNameHistory(data) {
        data = JSON.stringify({domainName: data});
        return axios.post(config.publicPath + 'domain-history', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
}
